var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-box"},[_c('p',{staticClass:"zhezhao"}),_c('el-button',{staticClass:"btn more",on:{"click":_vm.handleClickMore}},[_vm._v("更多"+_vm._s(_vm.typeName[_vm.type]))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }